(function() {

var _ = ui._;

ui.callback = function() {
  if(typeof bgcConfig !== 'undefined' && bgcConfig.openPassiveForm) {
    bgcConfig.openPassiveForm();
    return;
  }
  var btn = d.getElementById('bingc-phone-button');
  if(btn) {
    btn.click();
    return;
  }
  console.warn('Binotel GetCall widget is not ready yet');
};

ui.footerAccordion = function(btn) {
  var el = btn.nextElementSibling, c = el.classList, i = btn.querySelector('svg');
  if(c.contains('max-h-0')) {
    c.remove('max-h-0', 'opacity-0');
    c.add('max-h-96', 'opacity-100', 'pb-4');
    i.classList.add('rotate-180');
  } else {
    c.add('max-h-0', 'opacity-0');
    c.remove('max-h-96', 'opacity-100', 'pb-4');
    i.classList.remove('rotate-180');
  }
};

ui.seoToggle = function(btn) {
  var t = _('#seo-text').el, s = btn.querySelector('span'), i = btn.querySelector('svg');
  var open = t.style.maxHeight === '6rem';
  t.style.maxHeight = open ? t.scrollHeight + 'px' : '6rem';
  s.textContent = open ? (btn.dataset.less || '') : (btn.dataset.more || '');
  i.classList.toggle('rotate-180', !open);
};

d.addEventListener('DOMContentLoaded', function() {
  // Wrap admin tables inside rich content into a horizontal-scroll container
  // (full width on desktop, scrolls instead of squashing on narrow screens).
  d.querySelectorAll('.rich-content table:not(.stats)').forEach(function(table) {
    if(table.parentNode && table.parentNode.classList.contains('rich-table-scroll')) return;
    var wrap = d.createElement('div');
    wrap.className = 'rich-table-scroll';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  // Work status (contact page)
  var workStatus = _('#work-status').el;
  if(workStatus) {
    var now = new Date(), day = now.getDay(), h = now.getHours();
    if(day >= 1 && day <= 5 && h >= 9 && h < 18) {
      workStatus.className += ' text-green-600 bg-green-50';
      workStatus.innerHTML = '<div class="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>' + workStatus.dataset.open;
    } else {
      workStatus.className += ' text-gray-400 bg-gray-50';
      workStatus.innerHTML = '<div class="w-2 h-2 rounded-full bg-gray-400"></div>' + workStatus.dataset.closed;
    }
  }

  var bannerEl = d.querySelector('.bs-banner-swiper');
  if(bannerEl && typeof Swiper !== 'undefined') {
    new Swiper('.bs-banner-swiper', {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.bs-banner-swiper .swiper-pagination',
        clickable: true
      }
    });
  }

  // Blog product slider
  d.querySelectorAll('.bs-blog-products-swiper').forEach(function(el) {
    var wrap = el.parentElement;
    new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 8,
      freeMode: true,
      breakpoints: {
        340: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      },
      navigation: {
        prevEl: wrap ? wrap.querySelector('.blog-swiper-prev') : null,
        nextEl: wrap ? wrap.querySelector('.blog-swiper-next') : null
      }
    });
  });

  // Product sliders
  d.querySelectorAll('.bs-products-swiper').forEach(function(el) {
    new Swiper(el, {
      slidesPerView: 1.9,
      spaceBetween: 8,
      freeMode: true,
      breakpoints: {
        640: { slidesPerView: 3 },
        1024: { slidesPerView: 6 }
      }
    });
  });
  // Shared prev/next buttons control the visible swiper
  var prevBtn = d.querySelector('.product-swiper-prev');
  var nextBtn = d.querySelector('.product-swiper-next');
  function getActiveProductSwiper() {
    var visible = d.querySelector('.product-tab-content:not(.hidden) .bs-products-swiper');
    return visible && visible.swiper ? visible.swiper : null;
  }

  if(prevBtn)
    prevBtn.addEventListener('click', function() { var s = getActiveProductSwiper(); if(s) s.slidePrev(); });
  if(nextBtn)
    nextBtn.addEventListener('click', function() { var s = getActiveProductSwiper(); if(s) s.slideNext(); });

  // Viewed products
  if(typeof ui !== 'undefined') {
    ui.afterSessionInitAdd(function() {
      var viewed = ui.session_data.viewed;
      if(!viewed || !viewed.length)
        return;
      var wrapper = _('#viewed-swiper-wrapper').el;
      if(!wrapper)
        return;
      for(var i = 0; i < viewed.length; i++) {
        var p = ui.productGet(viewed[i]);
        if(!p)
          continue;
        var $slide = _('div').attr('class', 'swiper-slide', 'style', 'width: auto');
        $slide.append(ui.productBuild(p));
        wrapper.appendChild($slide.el);
      }
      var viewedSection = _('#viewed-section').el;
      if(viewedSection) {
        viewedSection.classList.remove('hidden');
        viewedSection.offsetHeight;
        new Swiper(viewedSection.querySelector('.bs-viewed-swiper'), {
          slidesPerView: 1.9,
          spaceBetween: 8,
          freeMode: true,
          observer: true,
          navigation: {
            prevEl: viewedSection.querySelector('.viewed-prev'),
            nextEl: viewedSection.querySelector('.viewed-next')
          },
          breakpoints: {
            640: { slidesPerView: 3 },
            1024: { slidesPerView: 6 }
          }
        });
      }
    });
  }

  // Reviews swiper
  if(d.querySelector('.bs-reviews-swiper')) {
    new Swiper('.bs-reviews-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      navigation: {
        prevEl: '.reviews-prev',
        nextEl: '.reviews-next'
      },
      breakpoints: {
        640: {
          slidesPerView: 2
        }
      }
    });
  }

  // Product tabs
  var tabs = d.querySelectorAll('.product-tab');
  var link = d.querySelector('.product-tab-link');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('active'); });
      tab.classList.add('active');
      var target = tab.getAttribute('data-tab');
      d.querySelectorAll('.product-tab-content').forEach(function(c) {
        c.classList.toggle('hidden', c.id !== target);
      });
      if(link)
        link.href = tab.getAttribute('data-href') || link.href;
      var sw = d.querySelector('#' + target + ' .bs-products-swiper');
      if(sw && sw.swiper)
        sw.swiper.update();
    });
  });
});

})();